import Query from "../utils/Query";

const defaultFields = '*,content.*,thumbnail.private_hash,image.private_hash,created_by.*,created_by.avatar.private_hash';

export default class NewsService {

	static getAll(lang) {
		return Query.get('/items/news', {
			fields: defaultFields,
			filter: {
				'content.language': lang,
			}
		});
	}

	static getLatest(lang) {
		return Query.get('/items/news', {
			single: 1,
			sort: '-id',
			fields: defaultFields,
			filter: {
				'content.language': lang,
			}
		});
	}

	static get(slug, locale) {
		return Query.get('/items/news', {
			single: 1,
			fields: defaultFields,
			filter: {
				'content.slug': slug,
				'content.language': locale,
			}
		});
	}
}
